import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HostCard from "components/cards/host-card";
import useAttendee from "../useHooks";
import { FilterDTO } from "utils/helpers/models/shared/filter.dto";
import { UserDTO } from "utils/helpers/models/shared/user.dto";
import { useSelector } from "react-redux";
import AttendeeBreadcrumb, { AttendeBreadcrumbLink } from "components/breadcrumbs/AttendeeBreadcrumb";
import { siteRoutes } from "utils/helpers/enums/routes";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import favHostsNotFoundGif from "assets/images/gifs/fav-not-found.gif";
import useStore from "hooks/useStore";

const FavouriteHosts: React.FC = () => {
  const navigate = useNavigate();
  const breadcrumbLinks: AttendeBreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.attendeeHome },
    { title: "Favorite Hosts", path: siteRoutes.attendeeFavoriteHosts },
  ];
  const [data, setData] = useState<UserDTO[]>([]);
  const [filters, setFilters] = useState<Partial<FilterDTO>>({
    page: 1,
    totalPages: 1,
    size: 10,
  });
  const { getFavoriteHosts } = useAttendee();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  const { isProfileCompleted } = useStore();

  // Check profile completion on mount - redirect to home if not completed
  useEffect(() => {
    const profileCompleted = isProfileCompleted();
    if (!profileCompleted) {
      navigate(siteRoutes.attendeeHome, { replace: true });
    }
  }, [isProfileCompleted, navigate]);

  const getAllFavHosts = (data: UserDTO[], filters: Partial<FilterDTO>) => {
    getFavoriteHosts(
      setData,
      { ...filters, page: filters.page - 1 },
      data,
      setFilters
    );
    setFilters({ ...filters });

    // Mark initial load as complete after first API call
    if (isInitialLoad) {
      setIsInitialLoad(false);
    }
  };

  useEffect(() => {
    getAllFavHosts([], filters);
  }, []);

  return (
    <div className="min-h-screen container">
      <AttendeeBreadcrumb links={breadcrumbLinks} />
      <div className="w-full flex justify-between gap-4">
        <h2 className="text-2xl font-bold mb-4 text-blackie py-5">
          Favorite Hosts
        </h2>
      </div>
      <div className="flex flex-wrap items-center gap-4 ">
        {data.map((host, index) => (
          <HostCard host={host} key={index} />
        ))}
      </div>
      {filters.totalPages > filters.page && (
        <div className="text-center mt-10">
          <button
            className="px-6 py-2 bg-fade text-primaryBlueText rounded-full"
            onClick={() =>
              getAllFavHosts(data, { ...filters, page: filters.page + 1 })
            }
          >
            See More
          </button>
        </div>
      )}

      <CustomMessageDisplay
        show={!isLoading && !data.length && !isInitialLoad}
        title="No Favorite Hosts"
        slogan="You haven't added any hosts to your favorites yet. Start exploring experiences and favorite hosts you love!"
        image={favHostsNotFoundGif}
        imageAlt="No favorite hosts found"
        className="py-12"
        imageClassName="w-[150px] h-[120px]"
        titleClassName="text-2xl font-bold text-blackie"
        sloganClassName="text-gray-500 text-base"
      />
    </div>
  );
};

export default FavouriteHosts;
